import "@fontsource-variable/fredoka";
import "@fontsource/azeret-mono/500.css";
import "@fontsource/azeret-mono/700.css";
import "@fontsource/pixelify-sans/500.css";
import "@fontsource/pixelify-sans/600.css";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { appRoutes, BrandedRouteFallback } from "./App";
import "./styles.css";

const router = createBrowserRouter(appRoutes);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<BrandedRouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
);
